// 계좌별 현금 잔액 관리 API (/api/balance)
import axiosInstance from './axiosInstance';

// 계좌별 잔액 요약 조회 (이월잔액+입금+매도+분배금-출금-매수)
export const fetchAccountSummary = async (year) => {
  const res = await axiosInstance.get('/balance/account-summary', { params: { year } });
  return res.data;
};

// 계좌별 입출금 내역 조회
export const fetchCashHistory = async (accountName, year) => {
  const res = await axiosInstance.get('/balance/history', {
    params: { account_name: accountName, year },
  });
  return res.data;
};

// 입출금 내역 등록
export const createCashHistory = async (payload) => {
  const res = await axiosInstance.post('/balance/history', payload);
  return res.data;
};

// 입출금 내역 수정
export const updateCashHistory = async (id, payload) => {
  const res = await axiosInstance.put(`/balance/history/${id}`, payload);
  return res.data;
};

// 입출금 내역 삭제
export const deleteCashHistory = async (id) => {
  const res = await axiosInstance.delete(`/balance/history/${id}`);
  return res.data;
};
